<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="secondary">
        <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/segment/listesi">{{ $t('menu.vehicleSegments') }}</router-link> / {{ form.name_readable }}
      </div>
      <div class="va-card__header-actions"/>
    </template>
    <form @submit.prevent="onsubmit">
      <input type="hidden" v-model="form.language"/>
      <div class="row">
        <div class="flex md4 sm6 xs12">
          <va-input
            v-model="form.name"
            label="İsim [EN]"
            placeholder="Segment ismi çevirisi girin"
          />
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import vehicleSegmentServices from '../../../services/api/vehicleSegment'
import responseMixin from '../../../services/api/response'
export default {
  mixins: [responseMixin],
  data () {
    return {
      form: {}
    }
  },
  methods: {
    async getVehicleSegment(id){
      const result = await vehicleSegmentServices.get(id);
      if(result.error){
        return ;
      }
      this.form = result.data.data;
      this.form.language = 'en';
      this.form.name = this.form.name.en ? this.form.name.en : '';
    },
    async putVehicleSegment(id) {
      const res = await vehicleSegmentServices.put(id, {
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('PUT', 'error', res);
        return ;
      }
      this.responseToast('PUT', 'success');
    },
    onsubmit () {
      //validation
      this.putVehicleSegment(this.$route.params.id);
    },
  },
  created () {
    if(this.$route.params.id) {
      this.getVehicleSegment(this.$route.params.id);
    }
  },
}
</script>